'use client';

import { useEffect } from 'react';

/** Scrolls to the element matching the URL hash once the client has rendered. */
export default function ShaojiangScrollToHash() {
  useEffect(() => {
    if (!window.location.hash) return;
    // Wait a frame so server-rendered content (e.g. article headings) is laid out
    const frame = requestAnimationFrame(() => {
      document.getElementById(decodeURIComponent(window.location.hash.slice(1)))?.scrollIntoView();
    });
    return () => cancelAnimationFrame(frame);
  }, []);

  return null;
}
